export enum ToolboxAction {
  SETTINGS = 'SETTINGS',
  PRINT = 'PRINT',
  BOOKMARK = 'BOOKMARK',
  GEOGEBRA_SCIENTIFIC = 'GEOGEBRA_SCIENTIFIC',
  GEOGEBRA_GRAPHING = 'GEOGEBRA_GRAPHING',
  GEOGEBRA_CAS = 'GEOGEBRA_CAS',
  FOLLOW_UP = 'FOLLOW_UP',
  KNOWLEDGE_BASE = 'KNOWLEDGE_BASE',
  FULLSCREEN = 'FULLSCREEN',
  SOLUTIONS = 'SOLUTIONS',
  NOTES = 'NOTES',
  MANUAL = 'MANUAL',
  PRESENTATION_MODE = 'PRESENTATION_MODE',
  PRESENTATION_MODE_UP = 'PRESENTATION_MODE_UP',
  PRESENTATION_MODE_DOWN = 'PRESENTATION_MODE_DOWN',
}
